import apiClient from '@/plugins/axios';

export default {
	getRoundHistoryItems(searchParam) {
		var query = `?PageNumber=${searchParam.currentPage}&PageSize=${searchParam.pageSize}`;
		query += searchParam.roundHistoryId
			? `&RoundHistoryId=${searchParam.roundHistoryId}`
			: '';
		query += searchParam.orderBy ? `&OrderBy=${searchParam.orderBy}` : '';

		return apiClient.get(`v1/RoundHistoryItem${query}`);
	},

	getRoundHistoryItem(roundHistoryItemId) {
		return apiClient.get(`v1/RoundHistoryItem/${roundHistoryItemId}`);
	},

	createRoundHistoryItem(roundHistoryItem) {
		return apiClient.post('v1/RoundHistoryItem', roundHistoryItem);
	},

	updateRoundHistoryItem(roundHistoryItem) {
		var roundHistoryItemId = roundHistoryItem.id;

		return apiClient.put(
			`v1/RoundHistoryItem/${roundHistoryItemId}`,
			roundHistoryItem
		);
	},

	deleteRoundHistoryItem(roundHistoryItemId) {
		return apiClient.delete(`v1/RoundHistoryItem/${roundHistoryItemId}`);
	}
};
